import React from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/es/format-message';
import { quizAnalysisPropType } from '../../common/propTypes';
import { Text } from '@instructure/ui-text';
import { Button } from '@instructure/ui-buttons';

/**
 * @deprecated this component is deprecated.
 * Please, use quiz-core/src/reporting/components/resources/common/ExportButton instead.
 */
export var ExportButton = function ExportButton(_ref) {
  var quizAnalysis = _ref.quizAnalysis,
    generationInProgress = _ref.generationInProgress,
    handleExport = _ref.handleExport;
  var renderExportButton = function renderExportButton(enabled) {
    var interaction = enabled ? 'enabled' : 'disabled';
    var color = enabled ? 'secondary' : 'primary-inverse';
    return /*#__PURE__*/React.createElement(Button, {
      color: color,
      interaction: interaction,
      onClick: handleExport,
      themeOverride: {
        lineHeight: '24px'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "medium"
    }, t('Export CSV')));
  };
  if (generationInProgress || !quizAnalysis) {
    return renderExportButton(false);
  }
  if (quizAnalysis) {
    return renderExportButton(true);
  }
};
ExportButton.propTypes = {
  quizAnalysis: quizAnalysisPropType.isRequired,
  generationInProgress: PropTypes.bool.isRequired,
  handleExport: PropTypes.func.isRequired
};
export default ExportButton;